import { Markdown } from '@davidlloydleisure/common-js-frontend';
import React, { use } from 'react';

import { SiteContext } from 'src/context/site-context';
import { getBrandForBuildType } from 'src/helpers/brand-for-build-type';
import { onMarkdownLinkClick } from 'src/helpers/markdown-helper';

import * as style from './copyright-information.module.scss';

type CopyrightInformationProps = {
  copyrightInformation: string;
  imagesDisclaimer: string;
};

const CopyrightInformation = ({
  copyrightInformation,
  imagesDisclaimer,
}: CopyrightInformationProps) => {
  const { buildType, isGlobalPage, language } = use(SiteContext);
  return (
    <div>
      {copyrightInformation && (
        <Markdown
          markdownText={copyrightInformation}
          brand={getBrandForBuildType(buildType)}
          onLinkClick={onMarkdownLinkClick(buildType, language, 'Copyright Information')}
          classNameToOverride={style.copyrightInformation}
        />
      )}
      {imagesDisclaimer && !isGlobalPage && <p className={style.disclaimer}>{imagesDisclaimer}</p>}
    </div>
  );
};

export { CopyrightInformation };
